/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { AlertItemsListDto, AlertItemDto, AlertDto } from '../api/alerts/alertsClient.typings';
import { Notification } from '../../utils/utils';
import { PageParams } from '../api/apiCommon.typings';

export enum AlertsDetailsActionType {
    OPEN_ALERTS_DETAILS_PAGE = 'AlertDetails/ open page',
    EXIT_ALERTS_DETAILS_PAGE = 'AlertDetails/ exit page',
    FETCH_ALERT_ITEMS_SUCCESS = 'AlertDetails/ fetch alert items success',
    FETCH_ALERT_DETAILS_SUCCESS = 'AlertDetails/ fetch details success',
    CHANGE_ALERT_ITEMS_PAGE = 'AlertDetails/ change items page',

    UPDATE_ALERT_DETAILS = 'AlertDetails/ update alert',
    UPDATE_ALERTS_DETAILS_SUCCESS = 'AlertDetails/ update alert success',

    UPDATE_ALERT_ITEM_REQ = 'AlertDetails/ update alert item req',
    UPDATE_ALERT_ITEM_SUCCESS = 'AlertDetails/ update alert item success',
    ALERTS_DETAILS_ERROR = 'AlertDetails/ alerts details error',
    REPORT_LOAD_START = 'AlertDetails/ report load start',
    REPORT_LOAD_FINISH = 'AlertDetails/ report load finish',
}

export const openAlertsDetailsPageAction = () => createAction(AlertsDetailsActionType.OPEN_ALERTS_DETAILS_PAGE);

export const exitAlertsDetailsPageAction = () => createAction(AlertsDetailsActionType.EXIT_ALERTS_DETAILS_PAGE);

export const fetchAlertItemsSuccessAction = (list: AlertItemsListDto) =>
    createAction(AlertsDetailsActionType.FETCH_ALERT_ITEMS_SUCCESS, list);

export const fetchAlertDetailsSuccessAction = (alert: AlertDto) =>
    createAction(AlertsDetailsActionType.FETCH_ALERT_DETAILS_SUCCESS, alert);

export const changeAlertItemsPageAction = (params: PageParams) =>
    createAction(AlertsDetailsActionType.CHANGE_ALERT_ITEMS_PAGE, params);

export const updateAlertItemRequestAction = (alertItemDto: AlertItemDto) =>
    createAction(AlertsDetailsActionType.UPDATE_ALERT_ITEM_REQ, alertItemDto);

export const updateAlertItemSuccessAction = (alertItemDto: AlertItemDto) =>
    createAction(AlertsDetailsActionType.UPDATE_ALERT_ITEM_SUCCESS, alertItemDto);

export const alertsDetailsErrorAction = (notification: Notification) => {
    return createAction(AlertsDetailsActionType.ALERTS_DETAILS_ERROR, { notification });
};

export const updateAlertDetailsAction = (alert: AlertDto[]) =>
    createAction(AlertsDetailsActionType.UPDATE_ALERT_DETAILS, alert);

export const updateAlertDetailsSuccess = (updatedAlert: AlertDto[]) =>
    createAction(AlertsDetailsActionType.UPDATE_ALERTS_DETAILS_SUCCESS, updatedAlert);

export const reportLoadStartAction = (alertId: AlertDto['id']) =>
    createAction(AlertsDetailsActionType.REPORT_LOAD_START, alertId);
export const reportLoadFinishAction = () => createAction(AlertsDetailsActionType.REPORT_LOAD_FINISH);

export type AlertsDetailsAction =
    | ReturnType<typeof fetchAlertItemsSuccessAction>
    | ReturnType<typeof exitAlertsDetailsPageAction>
    | ReturnType<typeof changeAlertItemsPageAction>
    | ReturnType<typeof updateAlertItemRequestAction>
    | ReturnType<typeof updateAlertItemSuccessAction>
    | ReturnType<typeof alertsDetailsErrorAction>
    | ReturnType<typeof reportLoadStartAction>
    | ReturnType<typeof reportLoadFinishAction>
    | ReturnType<typeof openAlertsDetailsPageAction>
    | ReturnType<typeof fetchAlertDetailsSuccessAction>
    | ReturnType<typeof updateAlertDetailsAction>
    | ReturnType<typeof updateAlertDetailsSuccess>;
